import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'
import { Dialog } from '../../_config/types'

export interface DialogReducer {
    dialog: Dialog
}

const initialState: DialogReducer = {
    dialog: null,
}

const dialogReducer = (state = initialState, action: ActionExtended) => {
    if (action.type === ACTIONS.DIALOG) {
        return {
            ...state,
            dialog: action.payload,
        }
    }
    return state
}

export default dialogReducer
